module.exports = __webpack_public_path__ + "static/media/tagHover.06427f63.svg";